module.exports = __webpack_public_path__ + "media/images/ico-new-rate-ae3c9f6f.svg";